export const greyDark = {
  25: '#16181d',
  50: '#16181d',
  100: '#1e2228',
  200: 'rgba(215, 219, 225, 0.1)',
  250: 'rgba(215, 219, 225, 0.16)',
  300: 'rgba(215, 219, 225, 0.14)',
  325: '#6b727e',
  350: '#88909c',
  375: '#88909c',
  400: '#6c727b',
  500: '#88909c',
  600: '#d7dbe1',
  900: '#d7dbe1'
};

export const error = {
  25: '#ffced0',
  50: '#ffced0',
  100: '#fccfcc',
  200: '#ffced0',
  300: '#ffced0',
  400: '#ef405e',
  500: '#d3132f',
  600: '#d3132f',
  700: '#d3132f',
  800: '#d3132f',
  900: '#d3132f'
};

export const warning = {
  25: '#fad67b',
  50: '#fad67b',
  100: '#f5d791',
  200: '#fad67b',
  300: '#fad67b',
  400: '#f8c52a',
  500: '#ecb700',
  600: '#ecb700',
  700: '#ecb700',
  800: '#ecb700',
  900: '#ecb700'
};

export const success = {
  25: '#a0e9cd',
  50: '#a0e9cd',
  100: '#b0e5d1',
  200: '#b0e5d1',
  300: '#a0e9cd',
  400: '#51d9ae',
  500: '#51caa5',
  600: '#51caa5',
  700: '#51caa5',
  800: '#51caa5',
  900: '#51caa5'
};

export const foamGreen = {
  100: '#a0e9cd',
  200: '#b0e5d1',
  300: '#b0e5d1',
  400: '#a0e9cd',
  500: '#51d9ae',
  600: '#51caa5',
  700: '#51caa5',
  800: '#51caa5',
  900: '#51caa5',
  1000: '#51caa5'
};

export const blue = {
  25: '#c5dcff',
  50: '#c5dcff',
  100: '#c6dbfd',
  200: '#c6dbfd',
  300: '#c5dcff',
  400: '#3580f2',
  500: '#1a6ce7',
  600: '#1a6ce7',
  700: '#1a6ce7',
  800: '#1a6ce7',
  900: '#1a6ce7'
};

export const darkPrimary = {
  '200': '#5d6a85',
  '100': '#191e24'
};

export const natomaBlack = '#d7dbe1';
export const natomaGreenDark = '#276ee1';
export const natomaDark = '#191e24';
